import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
    makeRequest('put', `/api/submissions/${id}/draft-evaluate`, payload);


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/grades/submitDraftEvaluation.js